export function drawerMenu() {
  document.querySelectorAll('.c-button__nav-switch').forEach((menuButton) => {
    menuButton.addEventListener('click', switchMenu);
    function switchMenu() {
      const navDrawer = document.getElementById('nav-drawer');
      navDrawer.classList.toggle('is-drawerActive');
    }
  });
}
